module.exports = __webpack_public_path__ + "img/button_prefix_on.e0758a0e.svg";